var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isAuthPage &&
    _vm.$store.state.auth.isCertificated === false &&
    !(_vm.$store.state.auth.certificateType == 5)
    ? _c(
        "div",
        { staticClass: "certification-alert-wrap" },
        [
          _c(
            "el-alert",
            {
              staticClass: "certification-alert",
              attrs: { type: "warning", "show-icon": "" }
            },
            [
              !_vm.isCompanyPage
                ? _c(
                    "p",
                    {
                      staticClass: "go-auth-tip",
                      attrs: { slot: "title" },
                      slot: "title"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t为保证账户安全，平台将对未实名认证用户进行能力调用次数以及其他权益限制，建议您优先完成实名认证"
                      ),
                      _c(
                        "router-link",
                        { attrs: { to: "/user/authentication" } },
                        [_vm._v("立即实名认证 >>")]
                      )
                    ],
                    1
                  )
                : _c(
                    "p",
                    {
                      staticClass: "go-auth-tip",
                      attrs: { slot: "title" },
                      slot: "title"
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t企业实名认证后，此账号将归属于认证企业。此账号今后在平台的任何操作，都视为企业授权行为。认证企业在提交申诉信息和有效证明文件前提下，可合理变更账号信息及操作权限。\n\t\t\t"
                      )
                    ]
                  )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47fc6329", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47fc6329","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/CertificationAlert/Main.vue
// module id = 760
// module chunks = 40